/**
 * The one e-mail check the forms share. Same rule as the sign-up and login
 * forms: something before the @, a domain, and a top-level part of at least
 * two letters. The API stays the authority; this only tells the user early.
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

export function isValidEmail(value: string | null | undefined): boolean {
  if (typeof value !== 'string') return false;
  return EMAIL_PATTERN.test(value.trim());
}

/** Splits a field that takes several addresses (comma, semicolon or space). */
export function splitEmails(value: string | null | undefined): string[] {
  if (typeof value !== 'string') return [];
  return value
    .split(/[,;\s]+/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

/** The addresses in the list that do not pass the check. */
export function invalidEmails(values: string[]): string[] {
  return values.filter((v) => !isValidEmail(v));
}
